const baseHtml = (data) => `
<p>Dear Subscriber,</p>
<p>Your request about <strong>${data.product}</strong> is <strong>${data.status}</strong>.</p>
${data.adminComment ? `<p><strong>Techmet Comment:</strong> ${data.adminComment}</p>` : ''}
<p>
    <strong>Company:</strong> ${data.company}<br>
    <strong>Product:</strong> ${data.product}<br>
    <strong>Category:</strong> ${data.category}<br>
    <strong>Concern about:</strong> ${data.subCategory}<br>
    <strong>Comments:</strong> ${data.comment}<br>
    <strong>Schedule Time:</strong> ${
      data.scheduledTime
        ? typeof data.scheduledTime === "object"
          ? data.scheduledTime.start && data.scheduledTime.end
            ? `${data.scheduledTime.start.substring(0, 16)} to ${
                data.scheduledTime.start.split(" ")[0] ===
                data.scheduledTime.end.split(" ")[0]
                  ? data.scheduledTime.end.split(" ")[1].substring(0, 5)
                  : data.scheduledTime.end.substring(0, 16)
              }`
            : data.scheduledTime.start ||
              (data.scheduledTime instanceof Date
                ? data.scheduledTime.toLocaleString()
                : "N/A")
          : data.scheduledTime
        : "N/A"
    }
</p>
<p>
    For any concerns, please contact your WhatsApp Group or call us.
</p>`;

const baseText = (data) => `Dear Subscriber,

Your request about "${data.product}" is "${data.status}".

${data.adminComment ? `Techmet Comment: ${data.adminComment}\n\n` : ''}*Company*: ${data.company}
*Product*: ${data.product}
*Category*: ${data.category}
*Concern about*: ${data.subCategory}
*Comments*: ${data.comment}
*Schedule Time*: ${
  data.scheduledTime
    ? typeof data.scheduledTime === "object"
      ? data.scheduledTime.start && data.scheduledTime.end
        ? `${data.scheduledTime.start.substring(0, 16)} to ${
            data.scheduledTime.start.split(" ")[0] ===
            data.scheduledTime.end.split(" ")[0]
              ? data.scheduledTime.end.split(" ")[1].substring(0, 5)
              : data.scheduledTime.end.substring(0, 16)
          }`
        : data.scheduledTime.start ||
          (data.scheduledTime instanceof Date
            ? data.scheduledTime.toLocaleString()
            : "N/A")
      : data.scheduledTime
    : "N/A"
}

For any concerns, please contact your WhatsApp Group or call us.`;

const getSubject = (data) => 
  data.status === "Resolved" ? "Ticket Resolved" : `Request Raised For ${data.product}`;

export const getTemplate = (data, type) => ({
  html: baseHtml(data),
  message: baseText(data),
  subject: getSubject(data),
});